import { render, staticRenderFns } from "./AllOrdingReturn.vue?vue&type=template&id=7428aff8&scoped=true"
import script from "./AllOrdingReturn.vue?vue&type=script&lang=js"
export * from "./AllOrdingReturn.vue?vue&type=script&lang=js"
import style0 from "./AllOrdingReturn.vue?vue&type=style&index=0&id=7428aff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7428aff8",
  null
  
)

export default component.exports